import React, { useState } from 'react';
import * as Sentry from '@sentry/react';
import { Route, Routes, useNavigate, Navigate } from 'react-router-dom';

import { GuestLogin } from './new-member-portal/Login';
import { GuestVerify } from './new-member-portal/Verify';
import { GuestUpload } from './new-member-portal/Upload';

export const NewMemberPortal = () => {
	const navigate = useNavigate();
	const [userData, setUserData] = useState<{
		emailAddress?: string;
		dob?: string;
		firstName?: string;
		lastName?: string;
		loginToken?: string;
		verificationCodeEmail?: string;
		uploadedFiles?: { [key: string]: File };
	}>({});

	const onVerifyStepClick = (data: { bsaId?: string; dob?: string; loginToken?: string; verificationCodeEmail?: string }) => {
		setUserData(data);
		navigate('/app/new-member/verify');
	};

	const signIn = (data: { emailAddress: string; dob: string; firstName: string; lastName: string; organization: string; token?: string }) => {
		setUserData(data);
		navigate('/app/new-member/upload');
	};

	return (
		<div className="frontend-page">
			<Routes>
				<Route path="new-member" element={<NewMemberPortal />} />
				<Route path="login" element={<GuestLogin onVerifyStepClick={onVerifyStepClick} />} />
				<Route path="verify" element={<GuestVerify data={userData} signIn={signIn} />} />
				<Route path="upload/*" element={<GuestUpload userData={userData} setUserData={setUserData} />} />
				<Route index element={<Navigate to="upload" replace />} />
			</Routes>
		</div>
	);
};
